import isFunction from 'lodash/isFunction';
import Button, { ButtonProps } from '@mui/material/Button';
import { useCallback, MouseEvent, useMemo } from 'react';
import { useNavigate } from 'react-router';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

export const BackButton = ({ onClick, children, ...props }: ButtonProps) => {
    const navigate = useNavigate();

    const handleClick = useCallback(
        (e: MouseEvent<HTMLButtonElement>) => {
            if (isFunction(onClick)) {
                onClick(e);
                return;
            }
            navigate(-1);
        },
        [navigate, onClick],
    );

    return (
        <Button variant="text" color="secondary" onClick={handleClick} startIcon={<ArrowBackRoundedIcon />} {...props}>
            {children}
        </Button>
    );
};
